import { render, staticRenderFns } from "./InformationNotMaintained.vue?vue&type=template&id=04b6323c&scoped=true&"
import script from "./InformationNotMaintained.vue?vue&type=script&lang=js&"
export * from "./InformationNotMaintained.vue?vue&type=script&lang=js&"
import style0 from "./InformationNotMaintained.vue?vue&type=style&index=0&id=04b6323c&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b6323c",
  null
  
)

export default component.exports